// extracted by mini-css-extract-plugin
module.exports = {"show":"index__show__UpSHO"};